import styled from 'styled-components';

export const Wrapper = styled.li`
  position: relative;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  background: #ffffff;
  box-shadow: 0px 0px 6px #00000021;

  width: 100%;

  padding: 0.8rem;

  border-radius: 0.4rem;

  transition: 180ms ease-in;

  position: relative;
  z-index: 1;

  &:hover {
    background: #ffffff99;
  }

  @media (min-width: 768px) {
    padding: 1.6rem 2.4rem 1.6rem;
  }
`;

export const Avatar = styled.img`
  background-color: #eee;

  width: 100%;
  max-width: 10rem;

  height: 100%;
  max-height: 10rem;
  object-fit: contain;

  border-radius: 0.4rem;

  margin-right: 2rem;

  @media (min-width: 1440px) {
    max-width: 14.6rem;
    max-height: 14.6rem;
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  width: 50%;
`;

export const Date = styled.p`
  font-size: 1.7rem;
  line-height: 2.1rem;
  color: #000000;
`;

export const Name = styled.h1`
  text-align: left;
  font-size: 2.3rem;
  line-height: 4rem;
  color: #000000;
  width: 90%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @media (min-width: 768px) {
    font-size: 3.3rem;
  }
`;

export const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  margin-top: 0.8rem;
`;

export const InfoIcon = styled.img`
  width: 100%;
  max-width: 3.8rem;

  height: 100%;
  max-height: 2.5rem;

  object-fit: contain;
`;

export const InfoText = styled.p`
  font-size: 1.2rem;
  line-height: 2.5rem;
  color: #000000;

  margin-left: 0.8rem;

  width: max-content;

  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @media (min-width: 1024px) {
    font-size: 2.1rem;
  }
`;

export const Options = styled.div`
  position: absolute;
  right: 3%;
  top: 17%;

  background: none;

  z-index: 99;
  cursor: pointer;

  > svg {
    &:hover {
      background: #dadada;
      border-radius: 50%;
    }
  }

  > div {
    display: flex;
    justify-content: center;
    flex-direction: column;

    position: absolute;
    left: -10rem;
    overflow: hidden;

    width: 14rem;

    background: #ffffff;

    box-shadow: 0px 0px 4px #40404030;
    border-radius: 2px;

    opacity: 0;

    transition: 300ms ease-in-out;
    pointer-events: none;

    .divider {
      height: 1px;
      background: #cbcbcb;
      margin: 0 0.3rem;
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      background: #ffffff;
      height: 4rem;
      border-radius: 0;

      color: #0f0f0f;
      font-size: 1.4rem;
      font-family: ${({ theme }) => theme.fontFamily.Nunito};
      font-weight: 600;
      line-height: 1.9rem;

      :last-child {
        color: #d90606;
      }

      &:hover {
        background: #40404030;
      }
    }
  }

  &:hover {
    > div {
      opacity: 1;
      pointer-events: visible;
    }
  }
`;

export const DeleteModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    margin-bottom: 3rem;
    text-transform: uppercase;
  }

  p {
    width: 80%;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 6rem;
  }

  div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    button {
      width: 10rem;
      height: 4rem;
      background: transparent linear-gradient(96deg, #000000 0%, #232323 100%)
        0% 0% no-repeat padding-box;
      border-radius: 50px;
      opacity: 1;

      color: #fff;
      font-weight: bold;

      transition: 0.2s;

      &:hover {
        filter: brightness(0.9);
      }
    }
  }
`;

export const GreenDot = styled.div`
  width: 100%;
  height: 100%;
  max-width: 3.8rem;
  max-height: 2.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  div {
    background-color: green;
    min-width: 20px;
    min-height: 20px;
    max-width: 20px;
    max-height: 20px;
    border-radius: 50%;
  }
`;

export const RedDot = styled.div`
  width: 100%;
  height: 100%;
  max-width: 3.8rem;
  max-height: 2.5rem;

  display: flex;
  align-items: center;
  justify-content: center;

  div {
    background-color: red;
    min-width: 20px;
    min-height: 20px;
    max-width: 20px;
    max-height: 20px;
    border-radius: 50%;
  }
`;
